import { useContext } from "react";
import { Navigate } from "react-router-dom";
import { AuthContext } from "../../context/AuthContext";

const ProtectedRoute = ({ children, role }) => {
  const { user } = useContext(AuthContext);

  // Not logged in
  if (!user) return <Navigate to="/" />;

  // Normalize role comparison (fix case issues)
  if (
    role &&
    String(user.role).toLowerCase() !== String(role).toLowerCase()
  ) {
    return <Navigate to="/" />;
  }

  return children;
};

export default ProtectedRoute;